export const currency = "UAH"